import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useLang, STR } from "@/i18n";

export default function FAQ() {
  const { lang } = useLang();
  const t = STR[lang];

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-1/3 -right-40 w-[30rem] h-[30rem] rounded-full bg-blue-700/10 blur-[150px] pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mono text-xs uppercase tracking-[0.3em] text-slate-500 mb-4"
        >
          {t.faq_eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight"
        >
          {t.faq_h2}
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="mt-10 flex flex-col gap-3">
            {t.faq_items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-white/10 rounded-2xl bg-[#0c1122]/80 backdrop-blur px-5 sm:px-6 overflow-hidden transition-colors duration-300 data-[state=open]:border-amber-400/40"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-bold text-sm sm:text-base text-white hover:no-underline hover:text-amber-300 py-5 transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
